module.exports = __webpack_public_path__ + "img/pro-zdIcon9.cb7bdca4.png";